module.exports = __webpack_public_path__ + "files/982cd4c5665f1faca29a5fe90d87b6cb.png";